import { makeStyles, Theme, darken } from '@material-ui/core/styles';
import { dimGray, slateblue, whiteSmoke } from 'styles/abstract/variables';

export const makeAvailabilityStyles = makeStyles({
    readMore: {
        color: slateblue,
        transition: 'color 0.3s ease',

        '&:hover': {
            color: darken(slateblue, 0.3),
            cursor: 'pointer',
        },
    },
    openButton: {
        lineHeight: 1.3,
    },
});

export const makeExpansionPanelClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            fontSize: '0.75rem',
            paddingLeft: theme.spacing(2),

            '&::before': {
                content: 'none',
            },

            '&$expanded': {
                margin: 0,
            },
        },
        expanded: {},
    }),
    { index: 1 },
);

export const makeExpansionPanelDetailsClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            color: dimGray,
            flexDirection: 'column',
            fontSize: '0.75rem',
            lineHeight: 1.3,
            padding: theme.spacing(0, 2.75),
            textAlign: 'justify',

            [theme.breakpoints.down('xs')]: {
                padding: 0,
            },
        },
    }),
    { index: 1 },
);

export const makeExpansionPanelSummaryClasses = makeStyles(
    (theme: Theme) => ({
        root: {
            fontSize: '0.75rem',
            minHeight: '1rem',
            padding: theme.spacing(0, 2.75),

            '&$expanded': {
                minHeight: theme.spacing(2),
            },

            '&:hover:not(.Mui-disabled)': {
                cursor: 'default',
            },
        },
        content: {
            margin: theme.spacing(0.25, 0, 0),

            '&$expanded': {
                margin: theme.spacing(0.25, 0, 0),
            },
        },
        expanded: {},
    }),
    { index: 1 },
);

export const makeDialogTitleStyles = makeStyles((theme: Theme) => ({
    root: {
        alignItems: 'center',
        background: whiteSmoke,
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),
        padding: theme.spacing(1, 2),
    },
}));
